import LoginHeader from './header'
import { Formik, Form } from 'formik'
import UseSendCode from './hooks/useSendCode'
import FormikInput from 'components/formikFields/input'
import { initialValues } from './utilities/initialValues'
import { LoginSchema } from './utilities/loginSchema'
import NextBtnIcon from '../../../assets/images/rectangle/next_button.svg'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'
import { FormEvent, useEffect, useState } from 'react'
import ShareNumberButton from 'components/miniapp/shareNumberButton'
import { checkLinkedNow, isMiniapp } from 'modules/miniapp'
import { POST_LOGIN_PATH } from 'utilities/navigation'
const Login = () => {
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    const { mutate } = UseSendCode(setIsSubmit)

    // Someone can leave the mini app, share their number with the bot, and come
    // back — the webhook links them while this page sits idle. Re-check on the
    // way back in so they are not still staring at a login form.
    useEffect(() => {
        if (!isMiniapp()) return
        const onVisible = () => {
            if (document.visibilityState !== 'visible') return
            checkLinkedNow().then((linked) => {
                if (linked) window.location.replace(POST_LOGIN_PATH)
            })
        }
        document.addEventListener('visibilitychange', onVisible)
        return () => document.removeEventListener('visibilitychange', onVisible)
    }, [])
    const handleOnChange = (event: FormEvent) => {
        //@ts-ignore
        if (!isSubmit && event.target.value.length === 11) {
            mutate({
                //@ts-ignore
                phone_number: toEnglishDigits(event.target.value),
            })
            setIsSubmit(true)
        }
    }
    return (
        <>
            <div className="flex flex-col justify-between items-center h-screen relative ">
                <div className=" flex flex-col w-full">
                    <LoginHeader />
                    <Formik
                        initialValues={initialValues}
                        validationSchema={LoginSchema}
                        onSubmit={async (values) => {
                            if (!isSubmit) {
                                mutate({
                                    phone_number: toEnglishDigits(
                                        values.phoneNumber
                                    ),
                                })
                                setIsSubmit(true)
                            }
                        }}
                    >
                        {({
                            submitForm,
                            values,
                            handleChange,
                            setFieldValue,
                        }) => (
                            <Form onChange={handleOnChange}>
                                <div className=" mx-3 mt-3 text-sm font-normal">
                                    <FormikInput
                                        type="number"
                                        label="شماره موبایل"
                                        name="phoneNumber"
                                        placeholder="برای مثال: ۰۹۱۲۳۴۵۶۷۸۹"
                                        className="text-sm font-normal"
                                        min={0}
                                    />
                                    {/* Mini-app only: fills the field from the
                                        messenger instead of typing 11 digits.
                                        The number is unsigned, so the SMS code
                                        below still does the proving. */}
                                    <ShareNumberButton
                                        disabled={isSubmit}
                                        // Fill only. Sharing the number is
                                        // often enough to log in outright, so
                                        // firing an OTP here would bill us for
                                        // a message the user never needs.
                                        onPrefill={(phone) =>
                                            setFieldValue('phoneNumber', phone)
                                        }
                                        // The explicit fallback, after the wait
                                        // came to nothing: same path as typing
                                        // eleven digits.
                                        onUseOtp={(phone) => {
                                            setFieldValue('phoneNumber', phone)
                                            if (!isSubmit) {
                                                mutate({ phone_number: phone })
                                                setIsSubmit(true)
                                            }
                                        }}
                                    />
                                </div>
                                <div className=" mt-4 text-center text-xs font-normal">
                                    <p>
                                        با ثبت‌نام و ورود به همیان،‌{' '}
                                        <a
                                            className=" text-blue-1 cursor-pointer"
                                            href="https://hamyanapp.com/policy/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            قوانین و مقررات
                                        </a>{' '}
                                        را می پذیرم.
                                    </p>
                                </div>
                                <div className="absolute bottom-5 right-5">
                                    <img
                                        src={NextBtnIcon}
                                        alt="nex-btn-icon"
                                        onClick={submitForm}
                                        className=" cursor-pointer"
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default Login
